/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cardano API
 * RESTful API for Cardano
 * OpenAPI spec version: 1.0.0
 */

/**
 * A change announced on `GET /api/events` (`text/event-stream`): one `data:` frame per event,
 * holding its JSON-encoded name. Not an operation in this document, since it never completes.
 */
export type AppEvent = typeof AppEvent[keyof typeof AppEvent];


export const AppEvent = {
  arbitrages_changed: 'arbitrages_changed',
  opportunities_changed: 'opportunities_changed',
  arbitrage_history_changed: 'arbitrage_history_changed',
  pools_changed: 'pools_changed',
  chain_advanced: 'chain_advanced',
  resync: 'resync',
} as const;
